export type SortDirection = 'asc' | 'desc';

export const naturalSort = (verdiA: string, verdiB: string, retning: SortDirection): number => {
    const sorteringssprak = navigator.languages[0] || navigator.language;
    const sorteringsprops = { numeric: true, ignorePunctuation: true };

    const compareResult = verdiA.localeCompare(verdiB, sorteringssprak, sorteringsprops);

    return compareResult * (retning === 'asc' ? 1 : -1);
};
